import {NameValues} from '@/modules/neodash/model/types/interfaces/NameValue';
import {i18nMixin} from '@/modules/neodash/mixins';

export default class FilterFormatters {
  public static formatLabelMultiSelect = (lst: NameValues): string =>
      !!lst.length ? lst.map(x => !!x && x.name).join(', ') : i18nMixin.methods.i18n('Common.All');
}
